import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

const styles = require('./Nav-styles.css');

const Nav = ({ className }) => (
  <nav className={classnames(styles.nav, className)}>
    <div className={styles.navcontent}>
      <NavLink className={styles.link} activeClassName={styles.activeLink} to="/current">2019</NavLink>
      <NavLink className={styles.link} activeClassName={styles.activeLink} to="/historical">HISTORICAL DATA</NavLink>
      <NavLink className={styles.link} activeClassName={styles.activeLink} to="/teams">TEAMS</NavLink>
      <NavLink className={styles.link} activeClassName={styles.activeLink} to="/about">ABOUT QLIK</NavLink>
    </div>
  </nav>
);

Nav.propTypes = {
  className: PropTypes.string,
};
Nav.defaultProps = {
  className: null,
};

export default Nav;
